export enum ProductStatus {
	ACCOUNTED = 'accounted',
	TAKEN_TO_WORK = 'taken_to_work__',
	REFUSAL__ = 'refusal__',
	REFUSAL__NO_NEED_INT_TIME = 'refusal__no_need_int_time',
	REFUSAL__ANOUTHER_BANK_PRODUCT = 'refusal__anouther_bank_product',
	REFUSAL__SBERBANK_PRODUCT = 'refusal__sberbank_product',
	REFUSAL__OTHER = 'refusal__other',
	REFUSAL__NOT_SITUABLEFOR_ACTIVE = 'refusal__not_suitablefor_active',
	REFUSAL__COVENANTS = 'refusal__covenants',
	REFUSAL__BAD_TECT_SUPPORT = 'refusal__bad_tect_support',
	REFUSAL__FEATURES_OF_PRODUCT = 'refusal__features_of_product',
	REFUSAL__INCORRECT_TASK = 'refusal__incorrect_task',
	REFUSAL__CATEGORICAL = 'refusal__categorical',
	REFUSAL__NEGATIVE_EXPERIENCE = 'refusal__negative_experience',
	REFUSAL__PRICE_BIT_PERCENT = 'refusal__price_bit_percent',
	REFUSAL__LOAN_TERM = 'refusal__loan_term',
	REFUSAL__LONG_TIME_FOR_CONNECT = 'refusal__long_time_for_conect',
	REFUSAL__INCORRECT_CONTACTS = 'refusal__incorrect_contacts',
	REFUSAL__LIQUIDATION = 'refusal__liquidation',
	REFUSAL__STOP_FACTOR_VND = 'refusal__stop_factor_VND',
	REFUSAL__CANCELED = 'refusal__canceled',
	REFUSAL__MISSED_CALL = 'refusal__missed_call',

	UNBLOCK_CHECKING = 'unblock_checking',
	UNBLOCK_CLARIFICATION = 'unblock_clarification',
	UNBLOCK_DECLINED = 'unblock_declined',
	ASSIGNED_CALL__NOT_RESPONDING = 'assigned_call__not_responding',
	ASSIGNED_CALL_TRANSFER__CALL_BY_CLIENT = 'assigned_call_transfer__call_by_client',

	AGREE_TO_PRODUCT_USER_REGISTRATION_IN_SBBOL = 'agree_to_product__user_registration_in_sbbol',
	AGREE_TO_PRODUCT_WAIT_USER_ACTION = 'agree_to_product__wait_user_action',
	AGREE_TO_PRODUCT_REGISTRATION_IN_BANK = 'agree_to_product__registration_in_bank',
	AGREE_TO_PRODUCT_REGISTRAYION_IN_OFFICE = 'agree_to_product__registrayion_in_office',
	AGREE_TO_PRODUCT_REGISTRATION_IN_SBBOL = 'agree_to_product__registration_in_sbbol',
	REATTACH_CONFIRMED = 'reattach_confirmed',
	REJECTED_BY_TIME = 'rejected_by_time',
	UNDEFINED = 'undefined',
	CLOSED = 'closed',
	NOT_ACCOUNTED = 'not_accounted',
	REATTACHED = 'reattached',
	CLIENT_IS_INTERESTED = 'client_is_interested',
	AGREE_TO_PRODUCT_CLIENT_IS_INTERESTED = 'agree_to_product__client_is_interested',
	REFUSAL = 'refusal',
	NEW_OFFER = 'new_offer',
	DRAFT = 'draft',
	AGREE_TO_PRODUCT_AND_WAIT_USER_ACTION = 'agree_to_product__and_wait_user_action',
	REFUSAL_OTHER = 'refusal_other',
}

export enum ProductStatusTranslate {
	ACCOUNTED = 'Учтена',
	TAKEN_TO_WORK = 'Принято в работу',
	NEW_OFFER = 'Принято в работу',

	UNBLOCK_CHECKING = 'На рассмотрении в ДС',
	UNBLOCK_CLARIFICATION = 'Возврат на доработку',

	ASSIGNED_CALL__NOT_RESPONDING = 'Назначен звонок',
	ASSIGNED_CALL_TRANSFER__CALL_BY_CLIENT = 'Назначен звонок',

	AGREE_TO_PRODUCT_USER_REGISTRATION_IN_SBBOL = 'Согласен на продукт',
	AGREE_TO_PRODUCT_WAIT_USER_ACTION = 'Согласен на продукт',
	AGREE_TO_PRODUCT_CLIENT_IS_INTERESTED = 'Согласен на продукт',
	AGREE_TO_PRODUCT_REGISTRATION_IN_BANK = 'Согласен на продукт',
	AGREE_TO_PRODUCT_REGISTRAYION_IN_OFFICE = 'Согласен на продукт',
	AGREE_TO_PRODUCT_REGISTRATION_IN_SBBOL = 'Согласен на продукт',
	CLIENT_IS_INTERESTED = 'Согласен на продукт',

	REATTACH_CONFIRMED = 'Перезакрепление подтверждено',
	UNBLOCK_DECLINED = 'Не учтена',
	REJECTED_BY_TIME = 'Не учтена',
	NOT_ACCOUNTED = 'Не учтена. Срок заявки истёк',
	REATTACHED = 'Не учтена',

	UNDEFINED = 'Статус не определен',

	REFUSAL = 'Отказ',
	REFUSAL__ = 'Отказ',
	REFUSAL__NO_NEED_INT_TIME = 'Нет потребности в настоящее время',
	REFUSAL__ANOUTHER_BANK_PRODUCT = 'Продукт есть в другом банке',
	REFUSAL__SBERBANK_PRODUCT = 'Продукт есть в Сбербанке',
	REFUSAL__OTHER = 'Отказ: прочее',
	REFUSAL__NOT_SITUABLEFOR_ACTIVE = 'Не подходит для деятельности клиента',
	REFUSAL__COVENANTS = 'Ковенанты/обязательства в другом банке',
	REFUSAL__BAD_TECT_SUPPORT = 'Не устраивает техподдержка',
	REFUSAL__FEATURES_OF_PRODUCT = 'Функциональные возможности продукта',
	REFUSAL__INCORRECT_TASK = 'Задача поставлена некорректно',
	REFUSAL__CATEGORICAL = 'Категорический отказ',
	REFUSAL__NEGATIVE_EXPERIENCE = 'Негативный опыт со Сбербанком',
	REFUSAL__PRICE_BIT_PERCENT = 'Не подошла цена/ставка/процент',
	REFUSAL__LOAN_TERM = 'Не подходит срок кредитования',
	REFUSAL__LONG_TIME_FOR_CONNECT = 'Долго оформлять/подключать',
	REFUSAL__INCORRECT_CONTACTS = 'Некорректные контакты',
	REFUSAL__LIQUIDATION = 'Ликвидация организации',
	REFUSAL__STOP_FACTOR_VND = 'Отказ банка: стоп-факторы/ВНД',
	REFUSAL__CANCELED = 'Отменено',

	CLOSED = 'Отказ',
	AGREE_TO_PRODUCT_AND_WAIT_USER_ACTION = 'Согласен на продукт',
	REFUSAL__MISSED_CALL = 'Отказ: Финальный недозвон',
	REFUSAL_OTHER = 'Отказ: прочее',
}

export const productStatusesCreate = [
	ProductStatus.REFUSAL,
	ProductStatus.CLOSED,
	ProductStatus.UNBLOCK_DECLINED,
	ProductStatus.REJECTED_BY_TIME,
	ProductStatus.NOT_ACCOUNTED,
	ProductStatus.REATTACHED,
	ProductStatus.ACCOUNTED,
]

export const productStatusesAvailableToAddReserve = [
	ProductStatus.TAKEN_TO_WORK,
	ProductStatus.NEW_OFFER,
	ProductStatus.ASSIGNED_CALL__NOT_RESPONDING,
	ProductStatus.ASSIGNED_CALL_TRANSFER__CALL_BY_CLIENT,
	ProductStatus.AGREE_TO_PRODUCT_CLIENT_IS_INTERESTED,
	ProductStatus.AGREE_TO_PRODUCT_REGISTRATION_IN_BANK,
	ProductStatus.AGREE_TO_PRODUCT_USER_REGISTRATION_IN_SBBOL,
	ProductStatus.AGREE_TO_PRODUCT_REGISTRATION_IN_SBBOL,
	ProductStatus.AGREE_TO_PRODUCT_REGISTRAYION_IN_OFFICE,
	ProductStatus.AGREE_TO_PRODUCT_WAIT_USER_ACTION,
	ProductStatus.UNBLOCK_CLARIFICATION,
	ProductStatus.UNBLOCK_CHECKING,
	ProductStatus.REATTACH_CONFIRMED,
	ProductStatus.ACCOUNTED,
	ProductStatus.DRAFT,
	ProductStatus.REFUSAL__STOP_FACTOR_VND,
	ProductStatus.REFUSAL__SBERBANK_PRODUCT,
	// eslint-disable-next-line no-underscore-dangle
	ProductStatus.REFUSAL__,
	ProductStatus.REFUSAL__OTHER,
	ProductStatus.REFUSAL__CANCELED,
	ProductStatus.REFUSAL__LIQUIDATION,
	ProductStatus.REFUSAL__INCORRECT_CONTACTS,
	ProductStatus.REFUSAL__LONG_TIME_FOR_CONNECT,
	ProductStatus.REFUSAL__LOAN_TERM,
	ProductStatus.REFUSAL__PRICE_BIT_PERCENT,
	ProductStatus.REFUSAL__NEGATIVE_EXPERIENCE,
	ProductStatus.REFUSAL__CATEGORICAL,
	ProductStatus.REFUSAL__INCORRECT_TASK,
	ProductStatus.REFUSAL__FEATURES_OF_PRODUCT,
	ProductStatus.REFUSAL__BAD_TECT_SUPPORT,
	ProductStatus.REFUSAL__COVENANTS,
	ProductStatus.REFUSAL__NOT_SITUABLEFOR_ACTIVE,
	ProductStatus.REFUSAL__ANOUTHER_BANK_PRODUCT,
	ProductStatus.REFUSAL__NO_NEED_INT_TIME,
	ProductStatus.REFUSAL__MISSED_CALL,
	ProductStatus.AGREE_TO_PRODUCT_AND_WAIT_USER_ACTION,
	ProductStatus.CLIENT_IS_INTERESTED,
	ProductStatus.REFUSAL_OTHER,
]
